import styled from 'styled-components';

// TODO pull values from theme
export const Checkbox = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid #999;
  border-radius: 4px;
  box-shadow: none;
  color: #fff;
  transition: all 0.2s;
  cursor: pointer;

  &:after {
    position: absolute;
    top: 4px;
    left: 9px;
    width: 6px;
    height: 12px;
    border-style: solid;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: all 0.2s ease-out;
    opacity: 0;
    pointer-events: none;
    content: '';
  }
`;

export const Wrapper = styled.div<{ color?: string }>`
  position: relative;
  display: inline-block;
  vertical-align: middle;

  input {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }

  input:checked ~ ${Checkbox}, input:indeterminate ~ ${Checkbox} {
    background: ${({ theme, color }) => color ?? theme.brand.primary.base};
    border-color: transparent;
    box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.4);

    &:after {
      opacity: 1;
    }
  }

  input:indeterminate ~ ${Checkbox}:after {
    top: 35%;
    left: 50%;
    width: 10px;
    height: 0;
    margin-top: 1px;
    border-width: 0 0 2px 0;
    transform: rotate(0) translate(-50%, -50%);
  }

  input:focus ~ ${Checkbox} {
    border-color: ${({ theme, color }) => color ?? theme.brand.primary.base};
  }

  input:disabled ~ ${Checkbox} {
    background: #f2f2f2;
    border-color: #d9d9d9;
    color: #d9d9d9;
  }
`;
